import React, { Component } from 'react';
import "./Timecode.scss"

class Timecode extends Component {
    constructor(props) {
        super();
    }
    render() {
        return (
            <div className="timecode" id={this.props.id}>
                <div className="time-area">
                    <div className="time-container">
                        <div className="time">{this.props.time}</div>
                    </div>
                    {!this.props.isEnd ? <div className="suffix">:</div> : ""}
                </div>
                <div className="desc">{this.props.desc}</div>
            </div>
        );
    }
}

export default Timecode;



// WEBPACK FOOTER //
// ./src/Components/NextGame/Ticker/Timecode.jsx